import { render, staticRenderFns } from "./notes_filter.vue?vue&type=template&id=21a6cb00&scoped=true"
import script from "./notes_filter.vue?vue&type=script&lang=js"
export * from "./notes_filter.vue?vue&type=script&lang=js"
import style0 from "./notes_filter.vue?vue&type=style&index=0&id=21a6cb00&prod&lang=scss&scoped=true"
import style1 from "./notes_filter.vue?vue&type=style&index=1&id=21a6cb00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6cb00",
  null
  
)

export default component.exports